
import levelingPartner from "@/app/infrastructures/misc/common-library/LevelingPartner";
import { ellipsisString } from "@/app/infrastructures/misc/Utils";
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { Options, prop, Vue } from "vue-class-component";
import OverlayPanel from "primevue/overlaypanel";

interface MitraData {
  reporter?: {
    partnerCode: string;
    partnerName: string;
    partnerUsername: string;
    partnerTier?: string;
    date: string;
    isYou?: boolean;
    avatar?: string;
  };
  escalation?: Array<{
    partnerCode: string;
    partnerName: string;
    partnerUsername: string;
    date: string;
    type?: string;
    isYou?: boolean;
    finishAt: string;
  }>;
  escalationBefore?: Array<{
    partnerCode: string;
    partnerName: string;
    partnerUsername: string;
    date: string;
    isYou?: boolean;
    type?: string;
    finishAt: string;
  }>;
  agent?: {
    partnerCode: string;
    partnerName: string;
    partnerUsername: string;
    partnerFullname: string;
    date: string;
  };
  followers?: Array<{
    partnerCode: string;
    partnerName: string;
    partnerUsername: string;
    isYou?: boolean;
    avatar?: string;
  }>;
}

class Props {
  data = prop<MitraData>({ required: true, default: () => ({}) });
  isSummary = prop<boolean>({
    type: Boolean,
    default: false
  });
}

@Options({
  components: {
    OverlayPanel
  }
})
export default class PartnerSection extends Vue.with(Props) {
  get level() {
    return this.data?.reporter?.partnerTier
      ? levelingPartner(this.data.reporter.partnerTier)
      : null;
  }

  ellipsisText(val: string, length: number) {
    return ellipsisString(val, length);
  }
  formatDateTime(date: any): string {
    return formatDate(date);
  }
  showEscalationModal = false;
  yourUsername(username: string) {
    return username.toLowerCase() === AccountController.accountData.username;
  }

  showAllFollowers = false;

  get displayedFollowers() {
    if (!this.data.followers?.length) return [];
    return this.showAllFollowers
      ? this.data.followers
      : this.data.followers.slice(0, 1);
  }

  toggleFollowersList() {
    this.showAllFollowers = !this.showAllFollowers;
  }

  get hasCurrentUser() {
    return (
      this.data.followers?.some((follower) =>
        this.yourUsername(follower.partnerUsername)
      ) ?? false
    );
  }

  get displayedFollowerCount() {
    if (!this.data.followers?.length) return 0;
    return this.hasCurrentUser
      ? this.data.followers.length - 1
      : this.data.followers.length;
  }

  mitraValueByCondition(val: any) {
    const parts = [val.partnerCode, val.partnerName];
    if (val.partnerUsername) parts.push(val.partnerUsername);
    if (val.partnerHubName) parts.unshift(val.partnerHubName);
    return parts.join(" - ");
  }

  toggleTooltip(event: any, partnerCode: string) {
    const refs: any = this.$refs;
    refs[partnerCode].toggle(event);
  }
}
